"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContentBeforeContainer = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _formInputTheme = require("./formInputTheme");
// not using sizing constant due to the 2px border (would be 12/sizes.small)
const StyledContentBeforeContainer = (0, _styled.default)("div")`
    padding-left: ${getPadding};
    display: flex;
`;
exports.StyledContentBeforeContainer = StyledContentBeforeContainer;
function getPadding(_ref) {
  let {
    themeMode,
    validationState,
    isFocused,
    focusMode,
    variant
  } = _ref;
  if (variant === "underline") {
    return `${_formInputTheme.formInputTheme.padding.left.rest(themeMode)}px`;
  } else if (validationState === "error") {
    return `${_formInputTheme.formInputTheme.padding.left.error(themeMode)}px`;
  } else if (isFocused && focusMode !== "keyboard") {
    return `${_formInputTheme.formInputTheme.padding.left.active(themeMode)}px`;
  } else {
    return `${_formInputTheme.formInputTheme.padding.left.rest(themeMode)}px`;
  }
}
//# sourceMappingURL=StyledContentBeforeContainer.js.map